const RELOAD_KEY = 'odg.chunk-reload-attempt';
const RELOAD_COOLDOWN_MS = 10_000;

const CHUNK_ERROR_PATTERNS = [
    /Failed to fetch dynamically imported module/i,
    /error loading dynamically imported module/i,
    /Importing a module script failed/i,
    /Loading chunk \d+ failed/i,
    /Unable to preload CSS for/i,
    /^Failed to fetch$/i,
    // WebKit (iOS Safari and every iOS "browser") throws this exact TypeError when
    // a dynamic import lands on the SPA fallback `index.html` after a hashed chunk
    // has been removed by a redeploy. Same recovery flow applies: reload to a
    // fresh document so the importer hits the new manifest.
    /is not a valid JavaScript MIME type/i,
];

export function isChunkLoadError(error: unknown): boolean {
    if (!(error instanceof Error)) {
        return false;
    }

    return CHUNK_ERROR_PATTERNS.some((pattern) => pattern.test(error.message));
}

export function tryReloadOnChunkError(targetPath: string, now: number = Date.now()): boolean {
    let lastAttempt = 0;

    try {
        const stored = sessionStorage.getItem(RELOAD_KEY);
        if (stored != null) {
            const parsed = Number(stored);
            if (!Number.isNaN(parsed)) {
                lastAttempt = parsed;
            }
        }
    } catch {
        // sessionStorage unavailable (private mode, disabled storage). Bail out
        // so we never reload without a working loop guard.
        return false;
    }

    if (now - lastAttempt < RELOAD_COOLDOWN_MS) {
        return false;
    }

    try {
        sessionStorage.setItem(RELOAD_KEY, String(now));
    } catch {
        // If we can't persist the marker we still proceed: a single recovery
        // reload is better than leaving the user stuck on a broken page.
    }

    window.location.assign(targetPath);
    return true;
}
